import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { ConfirmDialogComponent } from "../../_components/shared/confirm-dialog/confirm-dialog.component";
import { AlertDialogComponent } from "../../_components/shared/alert-dialog/alert-dialog.component";
import { ApproveDecisionModalComponent } from "src/app/_components/shared/approve-decision-modal/approve-decision-modal.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  private readonly unsavedChangesMsg =
    "You have unsaved work. Would you like to save before you close?";

  constructor(private dialog: MatDialog) {}

  openConfirmDialog(
    msg,
    okLabel: string = "Ok",
    cancelLabel: string = "Cancel",
    focusOnOk?: boolean
  ) {
    return this.dialog.open(ConfirmDialogComponent, {
      width: "800px",
      panelClass: "confirm-dialog-container",
      disableClose: true,
      data: {
        message: msg,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
        focusOnOk: focusOnOk
      },
    });
  }

  openUnsavedChangesDialog(
    msg: string = this.unsavedChangesMsg,
    okLabel: string = "Yes",
    cancelLabel: string = "No"
  ) {
    return this.dialog.open(ConfirmDialogComponent, {
      width: "800px",
      panelClass: "confirm-dialog-container",
      disableClose: true,
      data: {
        message: msg,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
      },
    });
  }

  openAlertDialog(msg, okLabel: string = "Ok", width: string ="400px", ariaLabelText?: string) {
    return this.dialog.open(AlertDialogComponent, {
      width: width,
      disableClose: true,
      autoFocus: true, 
      data: {
        message: msg,
        okLabel: okLabel,
        ariaLabelText
      },
    });
  }

  openDecisionDialog(title: string, msg: string,
    primaryBtn: string, secondaryBtn: string, cancelBtn:string,
    width: string = "600px", disableSignDecision:boolean= false) {
    return this.dialog.open(ApproveDecisionModalComponent, {
      width: width,
      disableClose: true,
      autoFocus: true,
      data: {
        title: title,
        message: msg,
        primaryButton: primaryBtn,
        secondaryButton: secondaryBtn,
        disableSecondaryBtn: disableSignDecision,
        cancelButton: cancelBtn
      },
    });
  }
}
